package com.merkost.handpass.admin.util

import kotlinx.browser.window

fun isDevPreview(): Boolean =
    window.location.hostname == "localhost" && window.location.search.contains("preview")
